// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10bcs","controls":"styles_controls__OeIvf","charLimit":"styles_charLimit__38W-E","input":"styles_input__1Mg7i","send":"styles_send__3zS6B"};